module.exports = __webpack_public_path__ + "static/img/freshman-blocky-hover.1c69f68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/he/freshman-blocky-hover.png
// module id = sMZi
// module chunks = 1